import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Modal from 'react-bootstrap/Modal';
import InputAuto from '../../helpers/input-auto';
import { catchError } from '../../helpers/catch-error'
import ReactLoading from 'react-loading';
import { validatePhone, validateAmount, validateEmail } from '../../helpers/common'
import { FaPen, FaThumbsUp, FaTrash } from "react-icons/fa";

const ClientInformation = ({ work_order, onWorkOrderChange, onWorkOrderCreated, is_loading = true, readOnly = false }) => {
    const navigate = useNavigate();
      const adminRole = parseInt(localStorage.getItem('@admin_role'), 10);

    const [client, setClient] = useState({
        client_id: "",
        client_company_name: "",
        client_address: "",
        client_city: "",
        client_state: "",
        client_zip: "",
        client_fee: "",
        client_receipt_type: 0,
        client_internal_notes: ""
    });
    const [clientAdd, setClientAdd] = useState({
        client_id: "",
        client_company_name: "",
        client_address: "",
        client_city: "",
        client_state: "",
        client_zip: "",
        client_fee: "",
        client_receipt_type: 0,
        client_internal_notes: ""
    });

    const [caseManager, setCaseManager] = useState({
        case_manager_id: "",
        case_manager_client_id: "",
        case_manager_first_name: "",
        case_manager_last_name: "",
        case_manager_email: "",
        case_manager_phone: "",
        case_manager_opt_in: 1,
        can_create_wo: 0,
    });
    const [caseManagerAdd, setCaseManagerAdd] = useState({
        case_manager_id: "",
        case_manager_client_id: "",
        case_manager_first_name: "",
        case_manager_last_name: "",
        case_manager_email: "",
        case_manager_phone: "",
        case_manager_opt_in: 1,
        can_create_wo: 1,
    });



    const [caseManagersList, setCaseManagersList] = useState(null);
    const [clientsCompanyNames, setClientsCompanyNames] = useState([])
    const [isBtn, setIsBtn] = useState(false)
    const [inputError, setInputError] = useState(false);
    const [clientSearch, setClientSearch] = useState({
        client_company_name: ""
    });
    const [isSearchClientModalOpen, setIsSearchClientModalOpen] = useState(false);
    const [isSearchCaseManagerModalOpen, setIsSearchCaseManagerModalOpen] = useState(false);

    const [searchResults, setSearchResults] = useState(null);
    const [advanceSearchResults, setAdvanceSearchResults] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [editCaseManagerMode, setEditCaseManagerMode] = useState(false);
    const [addMode, setAddMode] = useState(false);
    const [addCaseManagerMode, setAddCaseManagerMode] = useState(false);
    const [clientMask, setClientMask] = useState(true);
    const [contactAdd, setContactAdd] = useState(null);
    const [contactEdit, setContactEdit] = useState(null);
    const [contactsList, setContactsList] = useState(null);
    const [addContactMode, setAddContactMode] = useState(false);
    const [editContactMode, setEditContactMode] = useState(false);
    const [lorFile, setLORFile] = useState(null);
    const [caseManagerFilter, setCaseManagerFilter] = useState("");




    useEffect(() => {

        getClientsCompanyNames();

    }, []);



    useEffect(() => {
        if (work_order?.client_id > 0) {
            getClient(work_order?.client_id);
            getCaseManagers(work_order?.client_id);
            getContacts(work_order?.client_id);
            if (work_order?.case_manager_id > 0) {
                getCaseManager(work_order?.case_manager_id, work_order?.client_id);
            }

        }
        setAddMode(false);
        setEditMode(false);
        setIsSearchClientModalOpen(false);

    }, [work_order?.client_id]);



    const getClientsCompanyNames = async (e) => {


        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-clients-company-names", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setClientsCompanyNames(response?.data?.clients);

            } else {

                Swal.fire({ icon: "error", title: "Client Info", text: response?.data?.message });

            }
        }).catch(function (error) {

            catchError(error, navigate)

        });

    }


    const getClient = async (client_id) => {


        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-client-by-id/" + client_id, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setClient(response?.data?.client);

            } else {

                Swal.fire({ icon: "error", title: "Client Info", text: response?.data?.message });

            }
        }).catch(function (error) {

            catchError(error, navigate)

        });

    }


    const getCaseManager = async (case_manager_id, client_id) => {


        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-case-manager-by-id/" + case_manager_id + "/" + client_id, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setCaseManager(response?.data?.case_manager);

            } else {

                Swal.fire({ icon: "error", title: "Case Manager ", text: response?.data?.message });

            }
        }).catch(function (error) {

            catchError(error, navigate)

        });

    }


    const getCaseManagers = async (c) => {


        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-case-managers-by-client/" + c, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setCaseManagersList(response?.data?.case_managers);

            } else {

                Swal.fire({ icon: "error", title: "Client Info", text: response?.data?.message });

            }
        }).catch(function (error) {

            catchError(error, navigate)

        });

    }


    const getContacts = async (c) => {


        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-contacts-by-client/" + c, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setContactsList(response?.data?.contacts);

            } else {

                Swal.fire({ icon: "error", title: "Client Info", text: response?.data?.message });

            }
        }).catch(function (error) {

            catchError(error, navigate)

        });

    }

    const addClientToWorkOrder = async (client) => {

        setSearchResults(null);
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/add-client-to-work-order",
            {
                work_order_id: work_order?.work_order_id, client_id: client?.client_id
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    setClient(response?.data?.client);
                    onWorkOrderChange({ client_id: response?.data?.client?.client_id, case_manager_id: null });
                    if (response?.data?.client?.case_managers_count > 0) {
                        setIsSearchCaseManagerModalOpen(true);
                    }
                    setIsSearchClientModalOpen(false);



                } else {
                    Swal.fire({ icon: "error", title: "Client Info", text: response?.data?.message });
                    setIsBtn(false)
                }

            }).catch(function (error) {

                catchError(error, navigate)

            });




    }


    const saveClient = async (e) => {

        setIsBtn(true);
        let error_flag = false;

        const { client_company_name, client_address, client_city, client_state, client_zip, first_name, last_name, phone, fax, email, client_fee, client_fee_limit } = clientAdd;
        if (!client_company_name || !client_address || !client_city || !client_state || !client_zip || !first_name || !last_name || !phone || !email
            || !validateAmount(client_fee) || !validateAmount(client_fee_limit) || !validatePhone(phone) || !validateEmail(email)) {

            setInputError(true);
            setIsBtn(false);

        } else {

            var client_info = {
                client_company_name: clientAdd.client_company_name,
                client_address: clientAdd.client_address,
                client_city: clientAdd.client_city,
                client_state: clientAdd.client_state,
                client_zip: clientAdd.client_zip,
                client_fee: clientAdd.client_fee,
                client_fee_limit: clientAdd.client_fee_limit,
                client_receipt_type: clientAdd.client_receipt_type,
                client_internal_notes: clientAdd.client_internal_notes,
                first_name: clientAdd.first_name,
                last_name: clientAdd.last_name,
                email: clientAdd.email,
                phone: clientAdd.phone,
                fax: clientAdd.fax,
                email_opt_in: clientAdd.email_opt_in,


            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/add-client", client_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    client_info.client_id = response?.data?.client_id;
                    setClient(client_info);
                    setEditMode(false);
                    setCaseManagersList(null);

                    addClientToWorkOrder(client_info);
                    getContacts(response?.data?.client_id);


                } else {
                    Swal.fire({ icon: "error", title: "Client", text: response?.data?.message });

                }
                setIsBtn(false);

            }).catch(function (error) {

                setIsBtn(false);
                catchError(error, navigate)


            });

        }
    }

    const updateClient = async (e) => {

        setIsBtn(true);
        let error_flag = false;

        const { client_company_name, client_address, client_city, client_state, client_zip, client_fee, client_fee_limit } = client;
        if (!client_company_name || !client_address || !client_city || !client_state || !client_zip ||
            !validateAmount(client_fee) || !validateAmount(client_fee_limit)) {

            setInputError(true);
            setIsBtn(false);



        } else {

            var client_info = {
                client_id: client?.client_id,
                client_company_name: client?.client_company_name,
                client_address: client?.client_address,
                client_city: client?.client_city,
                client_state: client?.client_state,
                client_zip: client?.client_zip,
                client_fee: client.client_fee,
                client_fee_limit: client.client_fee_limit,
                client_phone: client?.client_phone,
                client_fax: client?.client_fax,
                client_receipt_type: client?.client_receipt_type,
                client_internal_notes: client?.client_internal_notes,
            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/update-client", client_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {


                    setClient(client_info);
                    setEditMode(false)

                } else {
                    Swal.fire({ icon: "error", title: "Client Info", text: response?.data?.message });

                }
                setIsBtn(false)

            }).catch(function (error) {

                Swal.fire({ icon: "error", title: "Client Info", text: error?.message });
                setIsBtn(false);
                catchError(error, navigate)


            });

        }


    }



    const saveCaseManager = async (e) => {

        setIsBtn(true);
        let error_flag = false;

        const { case_manager_first_name, case_manager_last_name, case_manager_email, case_manager_phone } = caseManagerAdd;
        if (!case_manager_first_name || !case_manager_last_name || !case_manager_email || !validateEmail(case_manager_email) || !validatePhone(case_manager_phone)) {


            setInputError(true);
            setIsBtn(false);

        } else {

            var case_manager_info = {
                client_id: work_order.client_id,
                work_order_id: work_order.work_order_id,
                case_manager_first_name: caseManagerAdd.case_manager_first_name,
                case_manager_last_name: caseManagerAdd.case_manager_last_name,
                case_manager_email: caseManagerAdd.case_manager_email,
                case_manager_phone: caseManagerAdd.case_manager_phone,
                case_manager_fax: caseManagerAdd.case_manager_fax,
                case_manager_opt_in: caseManagerAdd.case_manager_opt_in,
                can_create_wo: caseManagerAdd.can_create_wo,

            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/add-case-manager", case_manager_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    caseManager.case_manager_id = response?.data?.case_manager_id;
                    setCaseManager(case_manager_info);
                    setAddCaseManagerMode(false);
                    setEditCaseManagerMode(false);

                    addCaseManagerToWorkOrder(response?.data?.case_manager_id);
                    setIsBtn(false)
                } else {
                    Swal.fire({ icon: "error", title: "Case Manager ", text: response?.data?.message });
                    setIsBtn(false)
                }
            }).catch(function (error) {

                setIsBtn(false);
                catchError(error, navigate)

            });

        }
    }




    const updateCaseManager = async (e) => {

        setIsBtn(true);

        const { case_manager_first_name, case_manager_last_name, case_manager_email, case_manager_phone } = caseManager;
        if (!case_manager_first_name || !case_manager_last_name || !case_manager_email || !validateEmail(case_manager_email) || !validatePhone(case_manager_phone)) {

            setInputError(true);
            setIsBtn(false);

        } else {

            var case_manager_info = {
                case_manager_id: caseManager.case_manager_id,
                client_id: work_order.client_id,
                work_order_id: work_order.work_order_id,
                case_manager_first_name: caseManager.case_manager_first_name,
                case_manager_last_name: caseManager.case_manager_last_name,
                case_manager_email: caseManager.case_manager_email,
                case_manager_phone: caseManager.case_manager_phone,
                case_manager_fax: caseManager.case_manager_fax,
                case_manager_opt_in: caseManager.case_manager_opt_in,
                can_create_wo: caseManager.can_create_wo,

            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/update-case-manager", case_manager_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    setCaseManager(case_manager_info);
                    setAddCaseManagerMode(false);
                    setEditCaseManagerMode(false);

                    setIsBtn(false)
                } else {
                    Swal.fire({ icon: "error", title: "Client Info", text: response?.data?.message });
                    setIsBtn(false)
                }
            }).catch(function (error) {

                setIsBtn(false);
                catchError(error, navigate)

            });

        }
    }



    const addCaseManagerToWorkOrder = async (case_manager_id) => {

        setSearchResults(null);
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/add-case-manager-to-work-order",
            {
                work_order_id: work_order?.work_order_id, case_manager_id: case_manager_id
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    onWorkOrderChange({ case_manager_id: case_manager_id });
                    setCaseManager(response?.data?.case_manager);

                } else {
                    Swal.fire({ icon: "error", title: "Case Manager", text: response?.data?.message });
                    setIsBtn(false)
                }

            }).catch(function (error) {

                catchError(error, navigate)

            });




    }


    const saveContact = async (e) => {

        setIsBtn(true);
        const { first_name, last_name, email, phone } = contactAdd;
        if (!first_name || !last_name || !email || !phone || !validateEmail(email) || !validatePhone(phone)) {

            setInputError(true);
            setIsBtn(false);

        } else {

            var contact_info = {
                client_id: work_order.client_id,
                first_name: contactAdd.first_name,
                last_name: contactAdd.last_name,
                email: contactAdd.email,
                phone: contactAdd.phone,
                fax: contactAdd.fax,
                email_opt_in: contactAdd.email_opt_in,

            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/add-contact", contact_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    setAddContactMode(false);
                    setEditContactMode(false);
                    getContacts(work_order.client_id);
                    setIsBtn(false)
                } else {
                    Swal.fire({ icon: "error", title: "Case Manager ", text: response?.data?.message });
                    setIsBtn(false)
                }
            }).catch(function (error) {

                setIsBtn(false);
                catchError(error, navigate)

            });

        }
    }



    const updateContact = async () => {

        setIsBtn(true);
        const { first_name, last_name, email, phone } = contactEdit;
        if (!first_name || !last_name || !email || !validateEmail(email) || !validatePhone(phone)) {

            setInputError(true);
            setIsBtn(false);

        } else {

            var contact_info = {
                id: contactEdit.id,
                client_id: work_order.client_id,
                first_name: contactEdit.first_name,
                last_name: contactEdit.last_name,
                email: contactEdit.email,
                phone: contactEdit.phone,
                fax: contactEdit.fax,
                email_opt_in: contactEdit.email_opt_in,

            }
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/update-contact", contact_info, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status) {

                    setAddContactMode(false);
                    setEditContactMode(false);
                    getContacts(work_order.client_id);
                    setContactEdit(null)
                    setIsBtn(false)

                } else {
                    Swal.fire({ icon: "error", title: "Contact ", text: response?.data?.message });
                    setIsBtn(false)
                }
            }).catch(function (error) {

                setIsBtn(false);
                catchError(error, navigate)

            });

        }
    }


    const editContact = async (c) => {

        setEditContactMode(true);
        setContactEdit({
            id: c.id,
            client_id: c.client_id,
            first_name: c.first_name,
            last_name: c.last_name,
            email: c.email,
            fax: c.fax,
            phone: c.phone,
            email_opt_in: c.email_opt_in,
        })

    }



    const deactivateContact = async (id) => {

        setIsBtn(true);
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/deactivate-contact", { id: id }, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(async function (response) {

            if (response?.data?.status) {

                getContacts(work_order?.client_id);

                setIsBtn(false)
            } else {
                Swal.fire({ icon: "error", title: "Client Info", text: response?.data?.message });
                setIsBtn(false)
            }
        }).catch(function (error) {

            setIsBtn(false);
            catchError(error, navigate)

        });

    }



    const activateContact = async (id) => {

        setIsBtn(true);
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/activate-contact", { id: id }, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(async function (response) {

            if (response?.data?.status) {

                getContacts(work_order?.client_id);

                setIsBtn(false)
            } else {
                Swal.fire({ icon: "error", title: "Client Info", text: response?.data?.message });
                setIsBtn(false)
            }
        }).catch(function (error) {

            setIsBtn(false);
            catchError(error, navigate)

        });

    }

    const searchClient = (client_company_name = "", limit = 20) => {

        var search_elements = {}
        search_elements.client_company_name = client_company_name;

        search_elements.limit = limit;

        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/search-clients", search_elements, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {


            if (response?.data?.status) {

                let searched_clients = (
                    <>
                        <ul className="search-results-ul">
                            {response?.data?.clients?.map((p) => (
                                <li key={p.id} onClick={() => addClientToWorkOrder(p)} ><a className="btn btn-sm btn-link">{p.link}</a></li>
                            ))}
                        </ul>
                    </>
                );
                setSearchResults(searched_clients);

            }
            else {
                setSearchResults(null);

            }

        }).catch(function (error) {

            // setIsBtn(false);
            catchError(error, navigate)


        });


    }




    const advanceSearchClient = () => {

        setIsBtn(true);
        var search_elements = {}

        search_elements.client_company_name = clientSearch?.client_company_name;
        search_elements.client_address = clientSearch?.client_address;
        search_elements.client_city = clientSearch?.client_city;
        search_elements.client_state = clientSearch?.client_state;
        search_elements.client_contact_name = clientSearch?.client_contact_name;


        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/search-clients", search_elements, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {


            if (response?.data?.status) {

                if (response?.data?.clients?.length > 0) {
                    let searched_clients = (
                        <>

                            <ul className="search-results-ul">
                                {response?.data?.clients?.map((p) => (
                                    <li key={p.id} onClick={() => addClientToWorkOrder(p)} ><a className="btn btn-sm btn-link">{p.link}</a></li>
                                ))}
                            </ul>
                        </>
                    );
                    setAdvanceSearchResults(searched_clients);
                }
                else {
                    setAdvanceSearchResults(null);

                }

            }
            else {
                setAdvanceSearchResults(null);

            }
            setIsBtn(false);
        }).catch(function (error) {

            setIsBtn(false);
            catchError(error, navigate)

        });


    }



    const advanceSearchClientByName = (client_company_name = "") => {

        setIsBtn(true);
        var search_elements = {}
        search_elements.client_company_name = client_company_name;


        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/search-clients", search_elements, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {


            if (response?.data?.status) {

                let searched_clients = (
                    <>

                        <ul className="search-results-ul">
                            {response?.data?.clients?.map((p) => (
                                <li key={p.id} onClick={() => addClientToWorkOrder(p)} ><a className="btn btn-sm btn-link">{p.link}</a></li>
                            ))}
                        </ul>
                    </>
                );
                setAdvanceSearchResults(searched_clients);

            }
            else {
                setAdvanceSearchResults(null);

            }
            setIsBtn(false);
        }).catch(function (error) {

            setIsBtn(false);
            catchError(error, navigate)

        });


    }


    const toggleClientMask = () => {

        if (clientMask) {
            setClientMask(false);
        }
        else {
            setClientMask(true);

        }
    }

    const resetSearchClient = () => {

        setClientSearch({
            client_company_name: "",
        });

    }

    const resetCaseManagerAdd = () => {


        setCaseManagerAdd({
            case_manager_id: "",
            case_manager_client_id: "",
            case_manager_first_name: "",
            case_manager_last_name: "",
            case_manager_email: "",
            case_manager_fax: "",
            case_manager_phone: "",
            case_manager_opt_in: 1,
            can_create_wo: 1,
        })

    }

    const resetContactAdd = () => {


        setContactAdd({
            id: "",
            client_id: "",
            first_name: "",
            last_name: "",
            email: "",
            fax: "",
            phone: "",
            email_opt_in: 1,
        })

    }

    const resetClientAdd = () => {

        setClientAdd({
            client_id: "",
            client_company_name: "",
            client_address: "",
            client_city: "",
            client_state: "",
            client_zip: "",
            client_contact_name: "",
            client_contact_phone: "",
            client_contact_person: "",
            client_contact_email: "",
            client_alt_name: "",
            client_alt_phone: "",
            client_fee: "",
            client_alt_email: "",
            client_fee_limit: "",
            client_phone: "",
            client_fax: "",
            client_email: "",
            email_opt_in: 1,
            client_receipt_type: 1,
            client_notes: "",
            client_internal_notes: ""
        });
        setInputError(false);

    }


    const uploadLOR = async (client_id) => {
        if (!lorFile) {
            Swal.fire({ icon: "warning", title: "LOR", text: "Please select a PDF file." });
            return;
        }

        setIsBtn(true);

        const formData = new FormData();
        formData.append("lor_attachment", lorFile);
        formData.append("client_id", client_id);

        axios.post(
            process.env.REACT_APP_WEB_SERVICES_URL + "/admin/upload-lor",
            formData,
            {
                headers: { "Content-Type": "multipart/form-data" },
                withCredentials: true
            }
        )
            .then(response => {
                if (response?.data?.status) {
                    Swal.fire({ icon: "success", title: "Uploaded", text: "LOR uploaded successfully!" });
                    getClient(client_id);   // refresh data
                    setLORFile(null);
                } else {
                    Swal.fire({ icon: "error", title: "Upload Error", text: response?.data?.message });
                }
                setIsBtn(false);
            })
            .catch(error => {
                setIsBtn(false);
                catchError(error, navigate);
            });
    };

    const removeLOR = async () => {
        setIsBtn(true);

        axios.post(
            process.env.REACT_APP_WEB_SERVICES_URL + "/admin/delete-lor",
            { client_id: client.client_id },
            {
                headers: { "Content-Type": "application/json" },
                withCredentials: true
            }
        )
            .then(response => {
                if (response?.data?.status) {
                    Swal.fire({ icon: "success", title: "Deleted", text: "LOR removed!" });
                    getClient(client.client_id); // refresh
                } else {
                    Swal.fire({ icon: "error", title: "Error", text: response?.data?.message });
                }
                setIsBtn(false);
            })
            .catch(error => {
                setIsBtn(false);
                catchError(error, navigate);
            });
    };


    const filteredCaseManagers = useMemo(() => {
        if (!caseManagersList) return [];

        const term = caseManagerFilter.trim().toLowerCase();
        if (!term) return caseManagersList;

        return caseManagersList.filter(cm =>
            `${cm.case_manager_last_name} ${cm.case_manager_first_name}`
                .toLowerCase()
                .includes(term)
        );
    }, [caseManagersList, caseManagerFilter]);

    return (
        <>
            <div className="card card-form" >
                <div className="card-body p-0" >

                    <div className=" card-heading row m-0" >
                        <div className="col-md-5 col-sm-12 py-3 ps-3">  <h6 className=" fw-bold text-dark my-0">CLIENT INFORMATION

                        </h6></div>
                        {work_order?.status < 7 && !readOnly &&

                            <div className="col-md-7 col-sm-12 text-md-end -2 my-2">


                                {addMode ?
                                    <>
                                        <button onClick={() => saveClient()} className="btn btn-sm  btn-success me-1 " type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "SAVE"}</button>
                                        <button onClick={() => { setAddMode(false); resetClientAdd(); }} className="btn btn-sm  btn-warning me-1 " type="button">CANCEL SAVE</button>
                                        {/*  <button onClick={() => searchClient("", "", "", 5)} className="btn btn-sm btn-danger mx-1" type="button">Scan </button>*/}
                                    </>
                                    :
                                    <>
                                        {editMode ?
                                            <>
                                                <button onClick={() => updateClient()} className="btn btn-sm  btn-success me-1 " type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "UPDATE"}</button>
                                                <button onClick={() => setEditMode(false)} className="btn btn-sm   btn-warning me-1 " type="button">CANCEL UPDATE</button>
                                            </>

                                            :
                                            <>
                                                <button onClick={() => { resetClientAdd(); setAddMode(true) }} className="btn btn-sm  btn-success me-1 " type="button">NEW</button>
                                                <button onClick={() => { resetSearchClient(); setIsSearchClientModalOpen(true); setAdvanceSearchResults(null); setSearchResults() }} className="btn btn-sm btn-warning me-1 " type="button">ASSIGN EXISTING</button>
                                                {(work_order?.client_id > 0) &&
                                                    <>
                                                        <button onClick={() => setEditMode(true)} className="btn btn-sm    btn-danger me-1 " type="button">EDIT</button>
                                                      {adminRole !== 0 &&
                                                         <button onClick={() => toggleClientMask()} className="btn btn-sm btn-info me-1 " type="button">{clientMask ? "UN-MASK" : "MASK"} </button>
}
                                                         <a href={`/admin/report-work-orders-client/${work_order.client_id}`} className="btn btn-sm btn-primary me-1 " target="_blank">REPORT</a>

                                                    </>
                                                }
                                            </>
                                        }
                                    </>
                                }


                            </div>
                        }
                    </div>

                    {is_loading ?
                        <div className="text-center m-auto loader" >
                            <ReactLoading type={"cylon"} color={"#54418B"} height={250} width={250} />
                        </div>
                        :
                        <>
                            {(work_order?.client_id > 0 || addMode) ?
                                <form id="frm_client" >

                                    <div className="row " >

                                        <div className="col-xl-12 col-lg-12" >
                                            <div className="" >

                                                {(addMode) ?

                                                    <>

                                                        <div className="row px-3 py-2 gx-2 ">

                                                            <div className="col-3 my-2">
                                                                <label htmlFor="client_company_name" >Company Name*</label>

                                                                <InputAuto name="client_company_name" className="form-control" minStart="3"
                                                                    value={clientAdd.client_company_name}
                                                                    pholder=""
                                                                    data={clientsCompanyNames}
                                                                    field="client_company_name"
                                                                    onChange={(e) =>
                                                                        setClientAdd({ ...clientAdd, client_company_name: e })
                                                                    }
                                                                    onSelected={(e) => {

                                                                        searchClient(e.client_company_name, "", "", 10)
                                                                    }
                                                                    }

                                                                />

                                                                {inputError && !clientAdd?.client_company_name &&
                                                                    <span className="text-danger">Enter company Name</span>
                                                                }




                                                            </div>

                                                            <div className="col-3 my-2">
                                                                <label htmlFor="client_address">ADDRESS*</label>
                                                                <input name="client_address" id="client_address" type="text" className="form-control"
                                                                    value={clientAdd?.client_address}
                                                                    onChange={(e) =>
                                                                        setClientAdd({ ...clientAdd, client_address: e.target.value })
                                                                    }

                                                                />
                                                                {inputError && !clientAdd?.client_address &&
                                                                    <span className="text-danger">Enter address</span>
                                                                }


                                                            </div>

                                                            <div className="col-3 my-2">
                                                                <label htmlFor="client_city">CITY*</label>

                                                                <input name="client_city" id="client_city" type="text" className="form-control"
                                                                    value={clientAdd?.client_city}
                                                                    onChange={(e) =>
                                                                        setClientAdd({ ...clientAdd, client_city: e.target.value })
                                                                    }

                                                                />

                                                                {inputError && !clientAdd?.client_city &&
                                                                    <span className="text-danger">Enter city</span>
                                                                }

                                                            </div>

                                                            <div className="col-3 my-2">
                                                                <div className="row gx-2">

                                                                    <div className="col-6">
                                                                        <label htmlFor="client_state">STATE*</label>

                                                                        <input name="client_state" id="client_state" type="text"
                                                                            className="form-control"
                                                                            value={clientAdd?.client_state} onChange={(e) =>
                                                                                setClientAdd({ ...clientAdd, client_state: e.target.value })
                                                                            }
                                                                        />
                                                                        {inputError && !clientAdd?.client_state &&
                                                                            <span className="text-danger">Enter state</span>
                                                                        }

                                                                    </div>
                                                                    <div className="col-6">


                                                                        <label htmlFor="client_zip">ZIP*</label>

                                                                        <input name="client_zip" id="client_zip" type="text"
                                                                            className="form-control"
                                                                            value={clientAdd?.client_zip} onChange={(e) =>
                                                                                setClientAdd({ ...clientAdd, client_zip: e.target.value })
                                                                            }
                                                                        />

                                                                        {inputError && !clientAdd?.client_zip &&
                                                                            <span className="text-danger">Enter zip</span>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>



                                                        <div className="row px-3 py-1 gx-2 ">

{adminRole == 1 && (
    <>
    
  

                                                            <div className="col-2 my-2">
                                                                <label htmlFor="client_fee_limit">FEE LIMIT:(dd.cc)$</label>

                                                                <input name="client_fee_limit" id="client_fee_limit" type="text" className="form-control"
                                                                    value={clientAdd?.client_fee_limit} onChange={(e) =>
                                                                        setClientAdd({ ...clientAdd, client_fee_limit: e.target.value })
                                                                    }

                                                                />

                                                                {inputError && !validateAmount(clientAdd?.client_fee_limit) && (
                                                                    <span className="text-danger">Enter valid fee limit</span>
                                                                )}


                                                            </div>

                                                            <div className="col-2 my-2">
                                                                <label htmlFor="client_fee">CLIENT FEE:(dd.cc)$</label>

                                                                <input name="client_fee" id="client_fee" type="text" className="form-control"
                                                                    value={clientAdd?.client_fee} onChange={(e) =>
                                                                        setClientAdd({ ...clientAdd, client_fee: e.target.value })
                                                                    }

                                                                />

                                                                {inputError && !validateAmount(clientAdd?.client_fee) && (
                                                                    <span className="text-danger">Enter valid fee</span>
                                                                )}

                                                            </div>
  </>
)}
                                                            <div className="col-2 my-2">
                                                                <label htmlFor="client_receipt_type">Receipt Type:</label>
                                                                <div className="form-control py-2 border-2 border-dark px-1">

                                                                    <input type="radio" className="form-check-input me-1" name="client_receipt_type" value="1"
                                                                        onClick={() => setClientAdd({ ...clientAdd, client_receipt_type: 1 })} checked={(clientAdd?.client_receipt_type == 1) ? "true" : ""} />Ledger
                                                                    <input type="radio" className="form-check-input ms-2 me-1" name="client_receipt_type" value="0"
                                                                        onClick={() => setClientAdd({ ...clientAdd, client_receipt_type: 0 })} checked={(clientAdd?.client_receipt_type == 0) ? "true" : ""} />Invoice
                                                                </div>

                                                            </div>





                                                            <div className="col-6 py-2">
                                                                <label htmlFor="client_internal_notes">INTERNAL NOTES</label>

                                                                <textarea rows="1" name="client_internal_notes" id="client_internal_notes"
                                                                    className="form-control"
                                                                    onChange={(e) =>
                                                                        setClientAdd({ ...clientAdd, client_internal_notes: e.target.value })
                                                                    }
                                                                    value={clientAdd?.client_internal_notes}

                                                                >
                                                                    {clientAdd?.client_internal_notes}
                                                                </textarea>

                                                            </div>
                                                        </div>

                                                        <div className="row px-3 py-1 gx-2 ">

                                                            <div className="col-2 my-3">
                                                                <label htmlFor="first_name">Contact First Name</label>

                                                                <input name="first_name" id="first_name" type="text" className="form-control"
                                                                    value={clientAdd?.first_name}
                                                                    onChange={(e) =>
                                                                        setClientAdd({ ...clientAdd, first_name: e.target.value })
                                                                    }

                                                                />

                                                                {inputError && !clientAdd?.first_name &&
                                                                    <span className="text-danger">Enter First name</span>
                                                                }

                                                            </div>
                                                            <div className="col-2 my-3">
                                                                <label htmlFor="last_name">Contact Last Name</label>

                                                                <input name="last_name" id="last_name" type="text" className="form-control"
                                                                    value={clientAdd?.last_name}
                                                                    onChange={(e) =>
                                                                        setClientAdd({ ...clientAdd, last_name: e.target.value })
                                                                    }

                                                                />

                                                                {inputError && !clientAdd?.last_name &&
                                                                    <span className="text-danger">Enter Last Name</span>
                                                                }

                                                            </div>
                                                            <div className="col-2 my-3">
                                                                <label htmlFor="email">Contact Email</label>

                                                                <input name="email" id="email" type="text" className="form-control"
                                                                    value={clientAdd?.email}
                                                                    onChange={(e) =>
                                                                        setClientAdd({ ...clientAdd, email: e.target.value })
                                                                    }

                                                                />

                                                                {inputError && (!clientAdd?.email || !validateEmail(clientAdd?.email)) &&
                                                                    <span className="text-danger">Enter valid email</span>
                                                                }

                                                            </div>
                                                            <div className="col-2 my-3">
                                                                <label htmlFor="phone">Contact Phone</label>

                                                                <input name="phone" id="phone" type="text" className="form-control"
                                                                    value={clientAdd?.phone}
                                                                    onChange={(e) =>
                                                                        setClientAdd({ ...clientAdd, phone: e.target.value })
                                                                    }

                                                                />

                                                                {inputError && (!clientAdd?.phone || !validatePhone(clientAdd?.phone)) && (
                                                                    <span className="text-danger">Enter phone in xxx-xxx-xxxx format</span>
                                                                )}



                                                            </div>
                                                            <div className="col-2 my-3">
                                                                <label htmlFor="fax">Contact Fax</label>

                                                                <input name="fax" id="fax" type="text" className="form-control"
                                                                    value={clientAdd?.fax}
                                                                    onChange={(e) =>
                                                                        setClientAdd({ ...clientAdd, fax: e.target.value })
                                                                    }

                                                                />

                                                                {inputError && clientAdd?.fax && !validatePhone(clientAdd?.fax) && (
                                                                    <span className="text-danger">Enter fax in xxx-xxx-xxxx format</span>
                                                                )}


                                                            </div>

                                                            <div className="col-2 my-3">
                                                                <label htmlFor="email_opt_in" >Contact Email Opt-In</label>
                                                                <div className="form-control py-2 border-2 border-dark">

                                                                    <input type="radio" className="form-check-input " name="email_opt_in" value="1"
                                                                        onClick={() => setClientAdd({ ...clientAdd, email_opt_in: 1 })} checked={(clientAdd?.email_opt_in == 1) ? "true" : ""} /> Yes
                                                                    <input type="radio" className="form-check-input ms-3" name="email_opt_in" value="0"
                                                                        onClick={() => setClientAdd({ ...clientAdd, email_opt_in: 0 })} checked={(clientAdd?.email_opt_in == 0) ? "true" : ""} /> No

                                                                </div>
                                                            </div>

                                                        </div>

                                                    </>

                                                    :
                                                    <>
                                                        {editMode ?

                                                            <>


                                                                <div className="row px-3 py-2 gx-2 ">

                                                                    <div className="col-3 my-2">
                                                                        <label htmlFor="client_company_name" >Company Name*</label>

                                                                        <InputAuto name="client_company_name" className="form-control" minStart="3"
                                                                            value={client.client_company_name}
                                                                            pholder=""
                                                                            data={clientsCompanyNames}
                                                                            field="client_company_name"
                                                                            onChange={(e) =>
                                                                                setClient({ ...client, client_company_name: e })
                                                                            }
                                                                            onSelected={(e) => {

                                                                                searchClient(e.client_company_name, "", "", 10)
                                                                            }
                                                                            }

                                                                        />

                                                                        {inputError && !client?.client_company_name &&
                                                                            <span className="text-danger">Enter company Name</span>
                                                                        }




                                                                    </div>

                                                                    <div className="col-3 my-2">
                                                                        <label htmlFor="client_address">ADDRESS*</label>
                                                                        <input name="client_address" id="client_address" type="text" className="form-control"
                                                                            value={client?.client_address}
                                                                            onChange={(e) =>
                                                                                setClient({ ...client, client_address: e.target.value })
                                                                            }

                                                                        />
                                                                        {inputError && !client?.client_address &&
                                                                            <span className="text-danger">Enter address</span>
                                                                        }


                                                                    </div>

                                                                    <div className="col-3 my-2">
                                                                        <label htmlFor="client_city">CITY*</label>

                                                                        <input name="client_city" id="client_city" type="text" className="form-control"
                                                                            value={client?.client_city}
                                                                            onChange={(e) =>
                                                                                setClient({ ...client, client_city: e.target.value })
                                                                            }

                                                                        />

                                                                        {inputError && !client?.client_city &&
                                                                            <span className="text-danger">Enter city</span>
                                                                        }

                                                                    </div>

                                                                    <div className="col-3 my-2">
                                                                        <div className="row gx-2">

                                                                            <div className="col-6">
                                                                                <label htmlFor="client_state">STATE*</label>

                                                                                <input name="client_state" id="client_state" type="text"
                                                                                    className="form-control"
                                                                                    value={client?.client_state} onChange={(e) =>
                                                                                        setClient({ ...client, client_state: e.target.value })
                                                                                    }
                                                                                />
                                                                                {inputError && !client?.client_state &&
                                                                                    <span className="text-danger">Enter state</span>
                                                                                }

                                                                            </div>
                                                                            <div className="col-6">


                                                                                <label htmlFor="client_zip">ZIP*</label>

                                                                                <input name="client_zip" id="client_zip" type="text"
                                                                                    className="form-control"
                                                                                    value={client?.client_zip} onChange={(e) =>
                                                                                        setClient({ ...client, client_zip: e.target.value })
                                                                                    }
                                                                                />

                                                                                {inputError && !client?.client_zip &&
                                                                                    <span className="text-danger">Enter zip</span>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>

                                                                <div className="row px-3 py-2 gx-2 ">
{adminRole == 1 && (
    <>

                                                                    <div className="col-2 my-2">
                                                                        <label htmlFor="client_fee_limit">FEE LIMIT:(dd.cc)$</label>

                                                                        <input name="client_fee_limit" id="client_fee_limit" type="text" className="form-control"
                                                                            value={client?.client_fee_limit} onChange={(e) =>
                                                                                setClient({ ...client, client_fee_limit: e.target.value })
                                                                            }

                                                                        />

                                                                        {inputError && !validateAmount(client?.client_fee_limit) && (
                                                                            <span className="text-danger">Enter valid fee limit</span>
                                                                        )}


                                                                    </div>

                                                                    <div className="col-2 my-2">
                                                                        <label htmlFor="client_fee">CLIENT FEE:(dd.cc)$</label>

                                                                        <input name="client_fee" id="client_fee" type="text" className="form-control"
                                                                            value={client?.client_fee} onChange={(e) =>
                                                                                setClient({ ...client, client_fee: e.target.value })
                                                                            }

                                                                        />

                                                                        {inputError && !validateAmount(client?.client_fee) && (
                                                                            <span className="text-danger">Enter valid fee</span>
                                                                        )}

                                                                    </div>
</> 
)}

                                                                    <div className="col-2 my-2">
                                                                        <label htmlFor="client_receipt_type">Receipt Type:</label>
                                                                        <div className="form-control px-1 py-2 border-2 border-dark">

                                                                            <input type="radio" className="form-check-input me-1" name="client_receipt_type" value="1"
                                                                                onClick={() => setClient({ ...client, client_receipt_type: 1 })} checked={(client?.client_receipt_type == 1) ? "true" : ""} />Ledger
                                                                            <input type="radio" className="form-check-input ms-2 me-1" name="client_receipt_type" value="0"
                                                                                onClick={() => setClient({ ...client, client_receipt_type: 0 })} checked={(client?.client_receipt_type == 0) ? "true" : ""} />Invoice
                                                                        </div>

                                                                    </div>







                                                                    <div className="col-6 my-2">
                                                                        <label htmlFor="client_internal_notes">INTERNAL NOTES</label>

                                                                        <textarea rows="1" name="client_internal_notes" id="client_internal_notes"
                                                                            className="form-control"
                                                                            onChange={(e) =>
                                                                                setClient({ ...client, client_internal_notes: e.target.value })
                                                                            }
                                                                            value={client?.client_internal_notes}

                                                                        >
                                                                            {client?.client_internal_notes}
                                                                        </textarea>

                                                                    </div>




                                                                </div>



                                                            </>
                                                            :
                                                            <>
                                                                <div className="row px-3 py-2 gx-2 ">

                                                                    <div className="col-4 my-2">
                                                                        <label htmlFor="client_company_name" >Company Name</label><br />

                                                                        <label className="field-info">{client.client_company_name}</label>



                                                                    </div>

                                                                    <div className="col-4 my-2">
                                                                        <label htmlFor="client_address">ADDRESS</label><br />
                                                                        <label className="field-info">{client?.client_address}</label>


                                                                    </div>

                                                                    <div className="col-2 my-2">
                                                                        <label htmlFor="client_city">CITY</label><br />

                                                                        <label className="field-info">{client?.client_city}</label>
                                                                    </div>


                                                                    <div className="col-1">
                                                                        <label htmlFor="client_state">STATE</label><br />

                                                                        <label className="field-info">{client?.client_state}</label>
                                                                    </div>
                                                                    <div className="col-1">


                                                                        <label htmlFor="client_zip">ZIP</label><br />

                                                                        <label className="field-info">{client?.client_zip}</label>
                                                                    </div>

                                                                </div>

                                                                <div className="row px-3 py-2 gx-2 ">
                                                                    <div className="col-2 my-2">
                                                                        <label htmlFor="client_fee_limit">FEE LIMIT:(dd.cc)$</label><br />

                                                                        <label className="field-info"> {clientMask ? "****" : parseFloat(client?.client_fee_limit).toFixed(2)}</label>
                                                                    </div>

                                                                    <div className="col-2 my-2">
                                                                        <label htmlFor="client_fee">CLIENT FEE:(dd.cc)$</label><br />

                                                                        <label className="field-info"> {clientMask ? "****" : parseFloat(client?.client_fee).toFixed(2)} </label>

                                                                    </div>


                                                                    <div className="col-2 my-2">
                                                                        <label htmlFor="client_receipt_type">Receipt Type:</label><br />

                                                                        <label className="field-info" >{(client?.client_receipt_type == 1) ? "Ledger" : "Invoice"}</label>

                                                                    </div>


                                                                    <div className="col-6 my-2">
                                                                        <label htmlFor="client_internal_notes">INTERNAL NOTES: </label><br />

                                                                        <label className="field-info tt-none">{client?.client_internal_notes}</label>

                                                                    </div>




                                                                </div>


                                                                <div className="row py-2 mx-2 sub-heading">
                                                                    <div className="col">

                                                                        <div className="mt-1 fw-bold text-dark">CLIENT CONTACTS</div>

                                                                    </div>
                                                                    <div className="col text-end ">


                                                                        {(!work_order || work_order.client_id > 0 && work_order?.status < 7) && !readOnly &&

                                                                            <>

                                                                                {addContactMode ?
                                                                                    <>
                                                                                        <button onClick={() => saveContact()} className="btn btn-sm btn-sm btn-success me-1 " type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "SAVE"}</button>
                                                                                        <button onClick={() => setAddContactMode(false)} className="btn btn-sm btn-sm btn-warning me-1 " type="button">CANCEL SAVE</button>

                                                                                    </>
                                                                                    :
                                                                                    <>
                                                                                        {editContactMode ?
                                                                                            <>
                                                                                                <button onClick={() => updateContact()} className="btn btn-sm btn-sm btn-success me-1 " type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "UPDATE"}</button>
                                                                                                <button onClick={() => setEditContactMode(false)} className="btn btn-sm btn-sm btn-warning me-1 " type="button">CANCEL UPDATE</button>

                                                                                            </>
                                                                                            :
                                                                                            <button onClick={() => { resetContactAdd(); setAddContactMode(true); setInputError(false); }} className="btn btn-sm btn-sm btn-success me-1 " type="button">NEW</button>
                                                                                        }
                                                                                    </>
                                                                                }




                                                                            </>
                                                                        }




                                                                    </div>
                                                                </div>

                                                                {(addContactMode) &&
                                                                    <div className="row px-3 py-1 gx-2 ">

                                                                        <div className="col-2 my-3">
                                                                            <label htmlFor="first_name">Contact First Name</label>

                                                                            <input name="first_name" id="first_name" type="text" className="form-control"
                                                                                value={contactAdd?.first_name}
                                                                                onChange={(e) =>
                                                                                    setContactAdd({ ...contactAdd, first_name: e.target.value })
                                                                                }

                                                                            />

                                                                            {inputError && !contactAdd?.first_name &&
                                                                                <span className="text-danger">Enter First name</span>
                                                                            }

                                                                        </div>
                                                                        <div className="col-2 my-3">
                                                                            <label htmlFor="last_name">Contact Last Name</label>

                                                                            <input name="last_name" id="last_name" type="text" className="form-control"
                                                                                value={contactAdd?.last_name}
                                                                                onChange={(e) =>
                                                                                    setContactAdd({ ...contactAdd, last_name: e.target.value })
                                                                                }

                                                                            />

                                                                            {inputError && !contactAdd?.last_name &&
                                                                                <span className="text-danger">Enter Last Name</span>
                                                                            }

                                                                        </div>
                                                                        <div className="col-2 my-3">
                                                                            <label htmlFor="email">Contact Email</label>

                                                                            <input name="email" id="email" type="text" className="form-control"
                                                                                value={contactAdd?.email}
                                                                                onChange={(e) =>
                                                                                    setContactAdd({ ...contactAdd, email: e.target.value })
                                                                                }

                                                                            />

                                                                            {inputError && (!contactAdd?.email || !validateEmail(contactAdd?.email)) &&
                                                                                <span className="text-danger">Enter valid email</span>
                                                                            }

                                                                        </div>
                                                                        <div className="col-2 my-3">
                                                                            <label htmlFor="phone">Contact Phone</label>

                                                                            <input name="phone" id="phone" type="text" className="form-control"
                                                                                value={contactAdd?.phone}
                                                                                onChange={(e) =>
                                                                                    setContactAdd({ ...contactAdd, phone: e.target.value })
                                                                                }

                                                                            />

                                                                            {inputError && (!contactAdd?.phone || !validatePhone(contactAdd?.phone)) && (
                                                                                <span className="text-danger">Enter phone in xxx-xxx-xxxx format</span>
                                                                            )}



                                                                        </div>
                                                                        <div className="col-2 my-3">
                                                                            <label htmlFor="fax">Contact Fax</label>

                                                                            <input name="fax" id="fax" type="text" className="form-control"
                                                                                value={contactAdd?.fax}
                                                                                onChange={(e) =>
                                                                                    setContactAdd({ ...contactAdd, fax: e.target.value })
                                                                                }

                                                                            />

                                                                            {inputError && contactAdd?.fax && !validatePhone(contactAdd?.fax) && (
                                                                                <span className="text-danger">Enter fax in xxx-xxx-xxxx format</span>
                                                                            )}


                                                                        </div>

                                                                        <div className="col-2 my-3">
                                                                            <label htmlFor="email_opt_in" >Contact Email Opt-In</label>
                                                                            <div className="form-control py-2 border-2 border-dark">

                                                                                <input type="radio" className="form-check-input " name="email_opt_in" value="1"
                                                                                    onClick={() => setContactAdd({ ...contactAdd, email_opt_in: 1 })} checked={(contactAdd?.email_opt_in == 1) ? "true" : ""} /> Yes
                                                                                <input type="radio" className="form-check-input ms-3" name="email_opt_in" value="0"
                                                                                    onClick={() => setContactAdd({ ...contactAdd, email_opt_in: 0 })} checked={(contactAdd?.email_opt_in == 0) ? "true" : ""} /> No

                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                }
                                                                {(editContactMode) &&
                                                                    <div className="row px-3 py-1 gx-2 ">

                                                                        <div className="col-2 my-3">
                                                                            <label htmlFor="first_name">Contact First Name</label>

                                                                            <input name="first_name" id="first_name" type="text" className="form-control"
                                                                                value={contactEdit?.first_name}
                                                                                onChange={(e) =>
                                                                                    setContactEdit({ ...contactEdit, first_name: e.target.value })
                                                                                }

                                                                            />

                                                                            {inputError && !contactEdit?.first_name &&
                                                                                <span className="text-danger">Enter First name</span>
                                                                            }

                                                                        </div>
                                                                        <div className="col-2 my-3">
                                                                            <label htmlFor="last_name">Contact Last Name</label>

                                                                            <input name="last_name" id="last_name" type="text" className="form-control"
                                                                                value={contactEdit?.last_name}
                                                                                onChange={(e) =>
                                                                                    setContactEdit({ ...contactEdit, last_name: e.target.value })
                                                                                }

                                                                            />

                                                                            {inputError && !contactEdit?.last_name &&
                                                                                <span className="text-danger">Enter Last Name</span>
                                                                            }

                                                                        </div>
                                                                        <div className="col-2 my-3">
                                                                            <label htmlFor="email">Contact Email</label>

                                                                            <input name="email" id="email" type="text" className="form-control"
                                                                                value={contactEdit?.email}
                                                                                onChange={(e) =>
                                                                                    setContactEdit({ ...contactEdit, email: e.target.value })
                                                                                }

                                                                            />

                                                                            {inputError && (!contactEdit?.email || !validateEmail(contactEdit?.email)) &&
                                                                                <span className="text-danger">Enter Email</span>
                                                                            }

                                                                        </div>
                                                                        <div className="col-2 my-3">
                                                                            <label htmlFor="phone">Contact Phone</label>

                                                                            <input name="phone" id="phone" type="text" className="form-control"
                                                                                value={contactEdit?.phone}
                                                                                onChange={(e) =>
                                                                                    setContactEdit({ ...contactEdit, phone: e.target.value })
                                                                                }

                                                                            />

                                                                            {inputError && (!contactEdit?.phone || !validatePhone(contactEdit?.phone)) && (
                                                                                <span className="text-danger">Enter phone in xxx-xxx-xxxx format</span>
                                                                            )}



                                                                        </div>
                                                                        <div className="col-2 my-3">
                                                                            <label htmlFor="fax">Contact Fax</label>

                                                                            <input name="fax" id="fax" type="text" className="form-control"
                                                                                value={contactEdit?.fax}
                                                                                onChange={(e) =>
                                                                                    setContactEdit({ ...contactEdit, fax: e.target.value })
                                                                                }

                                                                            />

                                                                            {inputError && contactEdit?.fax && !validatePhone(contactEdit?.fax) && (
                                                                                <span className="text-danger">Enter fax in xxx-xxx-xxxx format</span>
                                                                            )}


                                                                        </div>

                                                                        <div className="col-2 my-3">
                                                                            <label htmlFor="email_opt_in" >Contact Email Opt-In</label>
                                                                            <div className="form-control py-2 border-2 border-dark">

                                                                                <input type="radio" className="form-check-input " name="email_opt_in" value="1"
                                                                                    onClick={() => setContactEdit({ ...contactEdit, email_opt_in: 1 })} checked={(contactEdit?.email_opt_in == 1) ? "true" : ""} /> Yes
                                                                                <input type="radio" className="form-check-input ms-3" name="email_opt_in" value="0"
                                                                                    onClick={() => setContactEdit({ ...contactEdit, email_opt_in: 0 })} checked={(contactEdit?.email_opt_in == 0) ? "true" : ""} /> No

                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                }
                                                                {(contactsList) &&
                                                                    <>

                                                                        <div className="row px-3 py-2 gx-2 ">
                                                                            <div className="col-1">
                                                                                <label className="control-label">Action</label>
                                                                            </div>
                                                                            <div className="col-2">
                                                                                <label className="control-label">Name:</label>
                                                                            </div>
                                                                            <div className="col-3">
                                                                                <label className="control-label">Email</label>
                                                                            </div>
                                                                            <div className="col-2">
                                                                                <label className="control-label">Phone</label>
                                                                            </div>
                                                                            <div className="col-2">
                                                                                <label className="control-label">Fax</label>
                                                                            </div>

                                                                            <div className="col-1">
                                                                                <label className="control-label">E-Opt-in</label>
                                                                            </div>
                                                                            <div className="col-1">
                                                                                <label className="control-label">Status</label>
                                                                            </div>


                                                                        </div>

                                                                        {contactsList && contactsList.length > 0 &&

                                                                            <div className="row px-3 py-2 gx-2 ">
                                                                                <div className="col-1">

                                                                                    {work_order.status < 7 && !readOnly &&
                                                                                        <>

                                                                                            <button type="button" className="btn btn-sm btn-sm btn-warning me-1" onClick={() => { editContact(contactsList[0]) }} ><FaPen title="Edit" /></button>
                                                                                            {contactsList[0].status == 1 ?
                                                                                                <button type="button" className="btn btn-sm btn-sm btn-danger me-1" onClick={() => { deactivateContact(contactsList[0].id) }} ><FaTrash title="Deactivate" /></button>
                                                                                                :
                                                                                                <button type="button" className="btn btn-sm btn-sm btn-success me-1" onClick={() => { activateContact(contactsList[0].id) }} ><FaThumbsUp title="Activate" /></button>

                                                                                            }
                                                                                        </>

                                                                                    }

                                                                                </div>
                                                                                <div className="col-2">
                                                                                    <label className="field-info" >

                                                                                        {contactsList[0]?.first_name + " " + contactsList[0]?.last_name}</label>
                                                                                </div>
                                                                                <div className="col-3">
                                                                                    <label className="field-info tt-none" >{contactsList[0]?.email}</label>
                                                                                </div>
                                                                                <div className="col-2">
                                                                                    <label className="field-info" >{contactsList[0]?.phone}</label>
                                                                                </div>
                                                                                <div className="col-2">
                                                                                    <label className="field-info" >{contactsList[0]?.fax}</label>
                                                                                </div>

                                                                                <div className="col-1">
                                                                                    <label className="field-info" >{contactsList[0]?.email_opt_in == 1 ? "YES" : "NO"}</label>
                                                                                </div>

                                                                                <div className="col-1">
                                                                                    <label className="field-info" >{contactsList[0]?.status == 1 ? "Active" : "Blocked"}</label>
                                                                                </div>

                                                                            </div>

                                                                        }




                                                                    </>

                                                                }

                                                            </>

                                                        }
                                                    </>
                                                }
                                                {client && client?.client_id > 0 &&
                                                    <>

                                                        <div className="row py-2 mx-2 sub-heading">
                                                            <div className="col">

                                                                <div className="mt-1 fw-bold text-dark">CASE MANAGER INFORMATION</div>

                                                            </div>
                                                            <div className="col-6 text-end ">


                                                                {(!work_order || work_order.client_id > 0 && work_order?.status < 7) && !readOnly &&

                                                                    <>

                                                                        {addCaseManagerMode ?
                                                                            <>
                                                                                <button onClick={() => saveCaseManager()} className="btn btn-sm btn-sm btn-success me-1 " type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "SAVE"}</button>
                                                                                <button onClick={() => setAddCaseManagerMode(false)} className="btn btn-sm btn-sm btn-warning me-1 " type="button">CANCEL SAVE</button>

                                                                            </>
                                                                            :
                                                                            <>
                                                                                {editCaseManagerMode ?
                                                                                    <>
                                                                                        <button onClick={() => updateCaseManager()} className="btn btn-sm  btn-sm btn-success me-1 " type="button" disabled={isBtn ? true : false} >{isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : "UPDATE"}</button>
                                                                                        <button onClick={() => setEditCaseManagerMode(false)} className="btn btn-sm  btn-sm btn-warning me-1 " type="button">CANCEL UPDATE</button>
                                                                                    </>

                                                                                    :
                                                                                    <>
                                                                                        <button onClick={() => { resetCaseManagerAdd(); setAddCaseManagerMode(true); setInputError(false); }} className="btn btn-sm btn-sm btn-success me-1 " type="button">NEW</button>
                                                                                        <button onClick={() => { setIsSearchCaseManagerModalOpen(true); }} className="btn btn-sm  btn-sm btn-warning me-1 " type="button">ASSIGN EXISTING</button>
                                                                                        {(work_order?.case_manager_id > 0) &&
                                                                                            <button onClick={() => setEditCaseManagerMode(true)} className="btn btn-sm  btn-sm  btn-danger me-1 " type="button">EDIT</button>
                                                                                        }
                                                                                    </>
                                                                                }
                                                                            </>
                                                                        }




                                                                    </>
                                                                }




                                                            </div>
                                                        </div>
                                                        {(addCaseManagerMode) ?
                                                            <>

                                                                <div className="row px-3 py-3 gx-2 ">
                                                                    <div className="col-2">
                                                                        <label htmlFor="case_manager_first_name">First Name*</label>
                                                                        <input name="case_manager_first_name" id="case_manager_first_name" type="text"
                                                                            className="form-control"
                                                                            value={caseManagerAdd.case_manager_first_name} onChange={(e) =>
                                                                                setCaseManagerAdd({ ...caseManagerAdd, case_manager_first_name: e.target.value })
                                                                            }
                                                                        />
                                                                        {inputError &&
                                                                            (!caseManagerAdd.case_manager_first_name || !(caseManagerAdd.case_manager_first_name.match(/^[A-Za-z'.\-, ]+$/))) && (
                                                                                <span className="text-danger">Enter valid first name</span>
                                                                            )}

                                                                    </div>
                                                                    <div className="col-2">
                                                                        <label htmlFor="case_manager_last_name">Last Name*</label>
                                                                        <input name="case_manager_last_name" id="case_manager_last_name" type="text"
                                                                            className="form-control"
                                                                            value={caseManagerAdd.case_manager_last_name} onChange={(e) =>
                                                                                setCaseManagerAdd({ ...caseManagerAdd, case_manager_last_name: e.target.value })
                                                                            }
                                                                        />
                                                                        {inputError &&
                                                                            (!caseManagerAdd.case_manager_last_name || !(caseManagerAdd.case_manager_last_name.match(/^[A-Za-z'.\-, ]+$/))) && (
                                                                                <span className="text-danger">Enter valid last name</span>
                                                                            )}

                                                                    </div>

                                                                    <div className="col-2">
                                                                        <label htmlFor="case_manager_email">Email*</label>
                                                                        <input name="case_manager_email" id="case_manager_email" type="text"
                                                                            className="form-control"
                                                                            value={caseManagerAdd.case_manager_email} onChange={(e) =>
                                                                                setCaseManagerAdd({ ...caseManagerAdd, case_manager_email: e.target.value })
                                                                            }
                                                                        />
                                                                        {inputError && (!caseManagerAdd?.client_email || !validateEmail(caseManagerAdd?.client_email)) &&
                                                                            <span className="text-danger">Enter valid email</span>
                                                                        }


                                                                    </div>

                                                                    <div className="col-2">
                                                                        <label htmlFor="case_manager_phone">PHONE</label>
                                                                        <input name="case_manager_phone" id="case_manager_phone" type="text"
                                                                            className="form-control"
                                                                            value={caseManagerAdd.case_manager_phone} onChange={(e) =>
                                                                                setCaseManagerAdd({ ...caseManagerAdd, case_manager_phone: e.target.value })
                                                                            }
                                                                        />


                                                                        {inputError && !validatePhone(caseManagerAdd?.case_manager_phone) && (
                                                                            <span className="text-danger">Enter phone in xxx-xxx-xxxx format</span>
                                                                        )}


                                                                    </div>






                                                                    <div className="col-2 ">
                                                                        <label htmlFor="case_manager_opt_in">Email Opt-In</label>
                                                                        <div className="form-control border-2 border-dark px-1">

                                                                            <input type="radio" className="form-check-input ms-3" name="case_manager_opt_in" value="1"
                                                                                onClick={() => setCaseManagerAdd({ ...caseManagerAdd, case_manager_opt_in: 1 })} checked={(caseManagerAdd.case_manager_opt_in == 1) ? "true" : ""} /> Yes
                                                                            <input type="radio" className="form-check-input ms-3" name="case_manager_opt_in" value="0"
                                                                                onClick={() => setCaseManagerAdd({ ...caseManagerAdd, case_manager_opt_in: 0 })} checked={(caseManagerAdd.case_manager_opt_in == 0) ? "true" : ""} /> No
                                                                        </div> </div>
                                                                    <div className="col-2 ">
                                                                        <label htmlFor="can_create_wo">Can Create Case</label>
                                                                        <div className="form-control border-2 border-dark px-1">

                                                                            <input type="radio" className="form-check-input ms-3" name="can_create_wo" value="1"
                                                                                onClick={() => setCaseManagerAdd({ ...caseManagerAdd, can_create_wo: 1 })} checked={(caseManagerAdd.can_create_wo == 1) ? "true" : ""} /> Yes
                                                                            <input type="radio" className="form-check-input ms-3" name="can_create_wo" value="0"
                                                                                onClick={() => setCaseManagerAdd({ ...caseManagerAdd, can_create_wo: 0 })} checked={(caseManagerAdd.can_create_wo == 0) ? "true" : ""} /> No
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>

                                                            :
                                                            <>
                                                                {(editCaseManagerMode) ?
                                                                    <>

                                                                        <div className="row px-3 py-3 gx-2 ">
                                                                            <div className="col-2">
                                                                                <label htmlFor="case_manager_first_name">First Name*</label>
                                                                                <input name="case_manager_first_name" id="case_manager_first_name" type="text"
                                                                                    className="form-control"
                                                                                    value={caseManager.case_manager_first_name} onChange={(e) =>
                                                                                        setCaseManager({ ...caseManager, case_manager_first_name: e.target.value })
                                                                                    }
                                                                                />
                                                                                {inputError &&
                                                                                    (!caseManager.case_manager_first_name || !(caseManager.case_manager_first_name.match(/^[A-Za-z'.\-, ]+$/))) && (
                                                                                        <span className="text-danger">Enter valid first name</span>
                                                                                    )}

                                                                            </div>
                                                                            <div className="col-2">
                                                                                <label htmlFor="case_manager_last_name">Last Name*</label>
                                                                                <input name="case_manager_last_name" id="case_manager_last_name" type="text"
                                                                                    className="form-control"
                                                                                    value={caseManager.case_manager_last_name} onChange={(e) =>
                                                                                        setCaseManager({ ...caseManager, case_manager_last_name: e.target.value })
                                                                                    }
                                                                                />
                                                                                {inputError &&
                                                                                    (!caseManager.case_manager_last_name || !(caseManager.case_manager_last_name.match(/^[A-Za-z'.\-, ]+$/))) && (
                                                                                        <span className="text-danger">Enter valid last name</span>
                                                                                    )}

                                                                            </div>

                                                                            <div className="col-2">
                                                                                <label htmlFor="case_manager_email">Email*</label>
                                                                                <input name="case_manager_email" id="case_manager_email" type="text"
                                                                                    className="form-control"
                                                                                    value={caseManager.case_manager_email} onChange={(e) =>
                                                                                        setCaseManager({ ...caseManager, case_manager_email: e.target.value })
                                                                                    }
                                                                                />
                                                                                {inputError &&
                                                                                    (!caseManager.case_manager_email || !caseManager.case_manager_email.match(/^$|^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) && (
                                                                                        <span className="text-danger">Enter valid email</span>
                                                                                    )}

                                                                            </div>

                                                                            <div className="col-2">
                                                                                <label htmlFor="case_manager_phone">PHONE</label>
                                                                                <input name="case_manager_phone" id="case_manager_phone" type="text"
                                                                                    className="form-control"
                                                                                    value={caseManager.case_manager_phone} onChange={(e) =>
                                                                                        setCaseManager({ ...caseManager, case_manager_phone: e.target.value })
                                                                                    }
                                                                                />

                                                                                {inputError && !validatePhone(caseManager?.case_manager_phone) && (
                                                                                    <span className="text-danger">Enter phone in xxx-xxx-xxxx format</span>
                                                                                )}


                                                                            </div>




                                                                            <div className="col-2 ">
                                                                                <label htmlFor="case_manager_opt_in">Email Opt-In</label>
                                                                                <div className="form-control border-2 border-dark px-1">
                                                                                    <input type="radio" className="form-check-input ms-3" name="case_manager_opt_in" value="1"
                                                                                        onClick={() => setCaseManager({ ...caseManager, case_manager_opt_in: 1 })} checked={(caseManager.case_manager_opt_in == 1) ? "true" : ""} /> Yes
                                                                                    <input type="radio" className="form-check-input ms-3" name="case_manager_opt_in" value="0"
                                                                                        onClick={() => setCaseManager({ ...caseManager, case_manager_opt_in: 0 })} checked={(caseManager.case_manager_opt_in == 0) ? "true" : ""} /> No
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-2">
                                                                                <label htmlFor="can_create_wo">Can Create Case</label>
                                                                                <div className="form-control border-2 border-dark px-1">

                                                                                    <input type="radio" className="form-check-input ms-3" name="can_create_wo" value="1"
                                                                                        onClick={() => setCaseManager({ ...caseManager, can_create_wo: 1 })} checked={(caseManager.can_create_wo == 1) ? "true" : ""} /> Yes
                                                                                    <input type="radio" className="form-check-input ms-3" name="can_create_wo" value="0"
                                                                                        onClick={() => setCaseManager({ ...caseManager, can_create_wo: 0 })} checked={(caseManager.can_create_wo == 0) ? "true" : ""} /> No
                                                                                </div> </div>
                                                                        </div>
                                                                    </>

                                                                    :
                                                                    <>
                                                                        {(caseManager && work_order?.case_manager_id > 0) ?
                                                                            <>

                                                                                <div className="row px-3 py-3 gx-2 ">
                                                                                    <div className="col-2">
                                                                                        <label htmlFor="case_manager_first_name">First Name</label><br />
                                                                                        <label className="field-info">{caseManager.case_manager_first_name}</label>


                                                                                    </div>
                                                                                    <div className="col-2">
                                                                                        <label htmlFor="case_manager_last_name">Last Name</label><br />
                                                                                        <label className="field-info">{caseManager.case_manager_last_name}</label>

                                                                                    </div>

                                                                                    <div className="col-3">
                                                                                        <label htmlFor="case_manager_email">Email</label><br />
                                                                                        <label className="field-info tt-none">{caseManager.case_manager_email}</label>


                                                                                    </div>


                                                                                    <div className="col-2">
                                                                                        <label htmlFor="case_manager_phone">PHONE</label><br />
                                                                                        <label className="field-info">{caseManager.case_manager_phone ? caseManager.case_manager_phone : ""}</label>
                                                                                    </div>




                                                                                    <div className="col-1 my-2">
                                                                                        <label htmlFor="case_manager_fax">OPT-IN</label><br />
                                                                                        <label className="field-info" >{(caseManager.case_manager_opt_in == 1) ? "Yes" : "No"}</label>

                                                                                    </div>


                                                                                    <div className="col-2 my-2">
                                                                                        <label htmlFor="case_manager_fax">CAN CREATE CASE</label><br />
                                                                                        <label className="field-info" >{(caseManager.can_create_wo == 1) ? "Yes" : "No"}</label>

                                                                                    </div>


                                                                                </div>
                                                                            </>
                                                                            :
                                                                            <div className="row px-3 py-3 gx-2 ">
                                                                                <div className="col-xl-12 col-lg-12 col-sm-12">
                                                                                    <h6>
                                                                                        Case Manager not assigned yet.
                                                                                    </h6>

                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </>


                                                                }
                                                            </>
                                                        }



                                                    </>
                                                }



                                                {searchResults &&
                                                    <>
                                                        <div className="row mt-2">
                                                            <div className="col-12">

                                                                <div className="sub-heading px-3 py-3 fw-bold text-dark">These records already exists in our database. Click on the link to add</div>

                                                            </div>
                                                        </div>


                                                        <div className="row">
                                                            <div className="col-12 pb-3 ps-4">
                                                                {searchResults}
                                                            </div>
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                        </div>


                                    </div>

                                </form>


                                :

                                <div className="row " >

                                    <div className="col-xl-12 col-lg-12 p-5" >

                                        <h5>In order to proceed with this case, please add a new or an existing client?.</h5>

                                    </div>

                                </div>
                            }
                        </>
                    }
                </div>



            </div>


            <Modal animation={false}
                show={isSearchClientModalOpen}
                onHide={() => { setIsSearchClientModalOpen(false); }}
                keyboard={false}
                backdrop="static"
                id="search-client-modal"
                size="lg"
            >
                <Modal.Header><h3 className="m-0 p-0">ADVANCE SEARCH</h3></Modal.Header>
                <Modal.Body>
                    <div className="modal-inner-content ">

                        <form className="form-horizontal form-thick"  >


                            <div className="row pb-4">

                                <div className="col-md-4 col-sm-12">
                                    <label htmlFor="client_company_name" >Client</label>
                                    <InputAuto name="client_company_name" className="form-control" minStart="3"
                                        value={clientSearch.client_company_name}
                                        pholder=""
                                        data={clientsCompanyNames}
                                        field="client_company_name"
                                        onChange={(e) =>
                                            setClientSearch({ ...clientSearch, client_company_name: e })
                                        }
                                        onSelected={(e) =>
                                            advanceSearchClientByName(e.client_company_name)
                                        }

                                    />


                                </div>



                                <div className="col-md-4 col-sm-12">
                                    <label htmlFor="client_address">Address</label>
                                    <input name="client_address" id="client_address" type="text" className="form-control"
                                        value={clientSearch.client_address}
                                        onChange={(e) =>
                                            setClientSearch({ ...clientSearch, client_address: e.target.value })
                                        }

                                    />
                                </div>
                                <div className="col-md-4 col-sm-12">
                                    <label htmlFor="client_city">City</label>
                                    <input name="client_city" id="client_city" type="text" className="form-control"
                                        value={clientSearch.client_city}
                                        onChange={(e) =>
                                            setClientSearch({ ...clientSearch, client_city: e.target.value })
                                        }

                                    />

                                </div>
                            </div>

                            <div className="row pb-4">
                                <div className="col-md-4 col-sm-12">
                                    <label htmlFor="client_state">State</label>
                                    <input name="client_state" id="client_state" type="text" className="form-control"
                                        value={clientSearch.client_state}
                                        onChange={(e) =>
                                            setClientSearch({ ...clientSearch, client_state: e.target.value })
                                        }

                                    />

                                </div>


                                <div className="col-md-4 col-sm-12 ">
                                    <label htmlFor="client_contact_name">Contact Name</label>
                                    <input name="client_contact_name" id="client_contact_name" type="text" className="form-control"
                                        value={clientSearch.client_contact_name} onChange={(e) =>
                                            setClientSearch({ ...clientSearch, client_contact_name: e.target.value })
                                        }
                                    />

                                </div>

                            </div>







                            <div className="modal-footer text-center m-auto">
                                <button type='button' onClick={() => advanceSearchClient()} className="btn btn-sm btn-lg btn-success" disabled={isBtn}>
                                    {isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status">

                                    </div><span className="sr-only">Loading...</span></> : 'Search'}
                                </button>
                                <button type='button' className="btn btn-sm btn-lg btn-warning" onClick={(e) => setIsSearchClientModalOpen(false)}  >Cancel</button>
                                <button className="btn btn-sm btn-danger" onClick={() => { resetClientAdd(); setAddMode(true); setIsSearchClientModalOpen(false); }} >New</button>


                            </div>
                            {advanceSearchResults &&
                                <>
                                    <div className="row">
                                        <div className="col-12 p-3 ps-4">
                                            <b>These records already exists in our database. Click on the link to add</b>
                                            {advanceSearchResults}
                                        </div>
                                    </div>
                                </>
                            }
                        </form>
                    </div>
                </Modal.Body>
            </Modal>





            <Modal animation={false}
                show={isSearchCaseManagerModalOpen}
                onHide={() => { setIsSearchCaseManagerModalOpen(false); }}
                keyboard={false}
                backdrop="static"
                id="search-case-manager-modal"
            >
                <Modal.Header>
                    <h3 className="m-0 p-0">CASE MANAGERS</h3>
                    <button onClick={() => { setIsSearchCaseManagerModalOpen(false); }} type="button" className="btn btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                </Modal.Header>
                <Modal.Body>
                    <div className="modal-inner-content ">


                        <div className="row pb-4">

                            <div className="col-md-12 col-sm-12">

                                {!caseManagersList ?
                                    <label>No case manager found</label>
                                    :
                                    <>
                                        <div className="mb-3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Filter case managers..."
                                                value={caseManagerFilter}
                                                onChange={(e) => setCaseManagerFilter(e.target.value)}
                                            />
                                        </div>

                                        <ul className="list-group">
                                            <li key={999}
                                                onClick={e => {

                                                    addCaseManagerToWorkOrder(null);
                                                    setIsSearchCaseManagerModalOpen(false);
                                                }}
                                                className={!work_order.case_manager_id ? "active list-group-item" : "list-group-item"}>


                                                <input key="0" name="case_manager" className="form-check-input mx-3" type="checkbox"
                                                    checked={!work_order.case_manager_id ? true : false}
                                                    onChange={e => {
                                                        addCaseManagerToWorkOrder(null);
                                                        setIsSearchCaseManagerModalOpen(false);
                                                    }} />
                                                None, Remove Case Manager
                                            </li>
                                            {filteredCaseManagers.length === 0 && (
                                                <li className="list-group-item text-muted text-center">
                                                    No matching case managers
                                                </li>
                                            )}
                                            {filteredCaseManagers?.map((cm, index) => (

                                                <li key={index} className={work_order.case_manager_id == cm.case_manager_id ? "active list-group-item" : "list-group-item"}
                                                    onClick={e => {

                                                        addCaseManagerToWorkOrder(cm.case_manager_id);
                                                        setIsSearchCaseManagerModalOpen(false);
                                                    }}
                                                >


                                                    <input key={cm.case_manager_id} name="case_manager" className="form-check-input mx-3" type="checkbox"
                                                        checked={work_order.case_manager_id == cm.case_manager_id ? true : false} value={cm.case_manager_id}
                                                        onClick={e => {

                                                            addCaseManagerToWorkOrder(cm.case_manager_id);
                                                            setIsSearchCaseManagerModalOpen(false);
                                                        }}
                                                    />
                                                    {cm.case_manager_last_name + " " + cm.case_manager_first_name}
                                                </li>

                                            ))}
                                        </ul>
                                    </>


                                }


                            </div>


                        </div>



                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <div className="container text-center">

                        <button onClick={() => { setIsSearchCaseManagerModalOpen(false); }} className="btn btn-warning me-1">Cancel</button>
                        <button className="btn btn-danger" onClick={() => { resetCaseManagerAdd(); setAddCaseManagerMode(true); setInputError(false); setIsSearchCaseManagerModalOpen(false); }} >New</button>

                    </div>

                </Modal.Footer>
            </Modal>




        </>

    );
};

export default ClientInformation;